module.exports = "/images/notFoundNeighborhood.svg";